import React from "react";

import Tab from "react-bootstrap/Tab";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

import "./ExpandedPostTabSwitcher.css";

import {
  PostAllRepliesComponent,
  PostAllEchoesComponent,
} from "./ExpandedPostLoadingLists";

export interface ExpandedPostTabSwitcherConfig {
  postId: string;
}

export function ExpandedPostTabSwitcher(
  props: ExpandedPostTabSwitcherConfig
): JSX.Element {
  return (
    <div>
      <hr style={{ marginBottom: 0 }} />
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Nav variant="pills" className="justify-content-center">
          <Nav.Item>
            <Nav.Link eventKey="first">All Replies</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="second">Echoes</Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          <hr style={{ marginTop: 0 }} />
          <Tab.Pane eventKey="first">
            {PostAllRepliesComponent(props.postId)}
          </Tab.Pane>
          <Tab.Pane eventKey="second">
            {PostAllEchoesComponent(props.postId)}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}
